'use client'

import type { FC } from 'react'
import { useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'

// Client-only share UI (still code-split)
const Share = dynamic(() => import('@/components/blog/shareButton'), {
  ssr: false,
  loading: () => <span className="inline-block h-10 w-[96px]" aria-hidden />,
})

const ShareButtonLoader: FC = () => {
  const ref = useRef<HTMLDivElement | null>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!ref.current || visible) return
    const io = new IntersectionObserver(
      ([e]) => e.isIntersecting && setVisible(true),
      { rootMargin: '200px' }, // start a bit early
    )
    io.observe(ref.current)
    return () => io.disconnect()
  }, [visible])

  return <div ref={ref}>{visible ? <Share /> : null}</div>
}

export default ShareButtonLoader
